module.exports = __webpack_public_path__ + "static/media/user.adc3e83e.png";